import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactData from "../../data/contact.json";
import { ContactSchema } from "../../data/validators";
import styles from "./ContactInfo.module.css";

interface SocialLink {
  platform: string;
  url: string;
}

const ContactInfoComponent: React.FC = () => {
  const contact = ContactSchema.parse(contactData);

  return (
    <section className={styles.contactSection}>
      <Container>
        <h2 className={styles.title}>Get in Touch</h2>
        <Row className="justify-content-center">
          <Col xs={12} md={6} className={styles.infoCol}>
            <p>
              <strong>Email:</strong>{" "}
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </p>
            <div className={styles.social}>
              {contact.social.map((s: SocialLink) => (
                <a
                  key={s.platform}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                >
                  {s.platform}
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactInfoComponent;
